export default class OembedHandler {
  constructor(selector = 'oembed[url]') {
    this.selector = selector;
  }

  init() {
    const oembedTags = document.querySelectorAll(this.selector);

    oembedTags.forEach((oembed) => {
      const url = oembed.getAttribute('url');
      const videoId = url ? this.extractYouTubeId(url) : null;

      if (!videoId || !oembed.parentNode) {
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}`;
      iframe.width = '560';
      iframe.height = '315';
      iframe.title = 'YouTube video player';
      iframe.frameBorder = '0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;

      oembed.parentNode.replaceChild(iframe, oembed);
    });
  }

  extractYouTubeId(url) {
    const regex = /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([^&\n?#]+)/;
    const match = url.match(regex);

    return match ? match[1] : null;
  }
}
